import classNames from 'classnames';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { webAndMobileDefaultProps, webAndMobileRootPropTypes } from 'ui/Plans/defaultProps';
import PlanTypeSelector from '../common/PlanTypeSelector';
import Credits from '../common/Credits';
import PlanCard from './PlanCard';
import PlanContent from '../common/PlanContent';
import PlanButton from '../common/PlanButton';
import AddonCard from './AddonCard';
import PaymentCoupons from '../common/PaymentCoupons';
import StaticIpCard from '../common/StaticIpCard';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = webAndMobileRootPropTypes;
const defaultProps = webAndMobileDefaultProps;

// Get tab from URL params
const getInitialTab = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  const validTabs = ['plans', 'addons', 'static-ip'];
  return validTabs.includes(tabParam) ? tabParam : 'plans';
};

const Mobile = ({
  planCycleType,
  setPlanCycleType,
  activePlanId,
  activePlanName,
  couponCode,
  setCouponCode,
  isApplied,
  appliedCouponConfig,
  creditBalance,
  setCreditBalance,
  isCreditApplied,
  setIsCreditApplied,
  message,
  currentCyclicPeriodPlans,
  currentCyclicPeriodAddons,
  staticIpPlans,
  userStaticIp,
  plansGroupedByCyclicMonths,
  shouldShowAddons,
  isSubscriptionActive,
  shouldShowCoupon,
  onCouponUpdate,
}) => {
  const [currentTab, setCurrentTab] = useState(getInitialTab);
  const [selectedPlanId, setSelectedPlanId] = useState(0);

  useEffect(() => {
    setSelectedPlanId(_.chain(currentCyclicPeriodPlans).orderBy('price', 'desc').first().value()?.id);
  }, [planCycleType]);

  const selectedPlan = _.find(currentCyclicPeriodPlans, { id: selectedPlanId }) || {
    historic_run_limit: 0,
    live_run_limit: 0,
    is_premium: false,
  };

  const {
    historic_run_limit: historicRunLimit,
    live_run_limit: liveRunLimit,
    is_premium: isPremium,
    is_pro: isPro,
  } = selectedPlan;

  // Check if current user's broker needs static IP
  // const currentUserBroker = window.currentUserBroker || '';
  // const staticIpBrokers = window.staticIpBrokers || [];
  // const shouldShowStaticIpTab = staticIpBrokers.includes(currentUserBroker);
  const shouldShowStaticIpTab = window.SA_FEATURE_FLAGS.shouldShowStaticIpPage || false;

  const tabConfigs = [
    { key: 'plans', label: 'Plans' },
    { key: 'addons', label: 'Add-ons' },
    ...(shouldShowStaticIpTab ? [{ key: 'static-ip', label: 'Static IP' }] : []),
  ];

  const renderli = (liConfig) => {
    const liClassName = classNames({
      'nav-link': true,
      active: currentTab === liConfig.key,
    });

    return (
      <li className="nav-item" key={liConfig.key}>
        <span className={liClassName} onClick={() => setCurrentTab(liConfig.key)}>
          {liConfig.label}
        </span>
      </li>
    );
  };

  const renderPlan = (plan, idx) => {
    return (
      <PlanCard
        plan={plan}
        key={idx}
        isActive={selectedPlanId === plan?.id}
        setSelectedPlanId={setSelectedPlanId}
        activePlanName={activePlanName}
        couponConfig={appliedCouponConfig}
        planCycleType={planCycleType}
        activePlanId={activePlanId}
        isSubscriptionActive={isSubscriptionActive}
        isCreditApplied={isCreditApplied}
        credits={isCreditApplied ? creditBalance : 0}
        couponCode={couponCode}
        onChangeCouponCode={setCouponCode}
        isApplied={isApplied}
        onCouponUpdate={onCouponUpdate}
        message={message}
        plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
      />
    );
  };

  const renderCouponAndCredits = () => {
    if (!shouldShowCoupon) return null;
    let headerClass = ' d-flex align-item-center gap-15 flex-column';
    headerClass += ' justify-content-center';

    return (
      <div className="d-flex align-items-center justify-content-center">
        <div className={headerClass}>
          {!ApplicationDomainUtility?.isCrypto
            ? (<PlanTypeSelector
            planCycleType={planCycleType}
            onHandlePlanType={setPlanCycleType}
            plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
            />)
            : null}
          
          <Credits
            creditBalance={creditBalance}
            isCreditApplied={isCreditApplied}
            onUpdateCredits={(newCreditBalance, isCreditUsed) => {
              setCreditBalance(newCreditBalance);
              setIsCreditApplied(isCreditUsed);
            }}
          />
          <PaymentCoupons
            couponCode={couponCode}
            onChangeCouponCode={setCouponCode}
            isApplied={isApplied}
            onCouponUpdate={onCouponUpdate}
            message={message}
            isMobile
          />
        </div>
      </div>
    );
  };

  const renderPlanContent = () => {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <div className="switch-btn"></div>
        </div>
        {currentTab !== 'static-ip' && renderCouponAndCredits()}
        <div className="plan-card-row">
          {_.map(_.orderBy(currentCyclicPeriodPlans, 'price', 'desc'), renderPlan)}
        </div>
        <div className="plan-desk">
          <div className="content-border border-bottom ">
            <p className="mt-2">Whats included</p>
          </div>
          <PlanContent
            isPremium={isPremium}
            parentClassName="plan-list"
            historicRunLimit={historicRunLimit}
            liveRunLimit={liveRunLimit}
            isPro={isPro}
          />
          <div className="d-block text-center mx-auto">
            <PlanButton
              btnClassName="btn btn-primary btn-lg mobile-order-now"
              plan={selectedPlan}
              isHideIcon
              activePlanId={activePlanId}
              couponConfig={appliedCouponConfig}
              activePlanName={activePlanName}
              isSubscriptionActive={isSubscriptionActive}
              isCreditApplied={isCreditApplied}
              couponCode={couponCode}
              onChangeCouponCode={setCouponCode}
              isApplied={isApplied}
              onCouponUpdate={onCouponUpdate}
              message={message}
              plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderAddon = (addon, id) => (
    <AddonCard
      key={id}
      addon={addon}
      purchaseType="addon"
      couponConfig={appliedCouponConfig}
      credits={isCreditApplied ? creditBalance : 0}
    />
  );

  const renderAddonsContent = (isShowCreditAndCoupon = true) => {
    if (!shouldShowAddons) return null;
    if (_.isEmpty(currentCyclicPeriodAddons)) return null;

    return (
      <>
        {isShowCreditAndCoupon && renderCouponAndCredits()}
        <div className="addon-card-mobile">{_.map(currentCyclicPeriodAddons, renderAddon)}</div>
      </>
    );
  };

  const renderStaticIpPlans = () => {
    if (_.isEmpty(staticIpPlans)) return null;

    const currentUserBroker = window.currentUserBroker || '';
    const staticIpBrokers = window.staticIpBrokers || [];
    const isIpMandatedBroker = staticIpBrokers.includes(currentUserBroker);
    const isUserSignedIn = window.isUserSignedIn;

    let infoMessage = isIpMandatedBroker
      ? 'Your broker requires a user dedicated static IP.'
      : 'Your broker does not require a dedicated static IP.';
    infoMessage += ' Please contact support if you have any questions or refer to this blog';

    if (!isUserSignedIn) {
      infoMessage = 'For more information, Please contact support or refer to this blog';
    }

    return (
      <div className="col-lg-12 col-md-6 col-12">
        <div className="aler-message-box mb-4">
          <div className="icon-text">
            <i className="fa-regular fa-circle-info"></i>
            {infoMessage}
          </div>
          <a
            href="https://www.quantman.trade/blog/understanding-sebis-static-ip-requirements"
            target="_blank"
            rel="noreferrer"
          >
            Read More<i className="fa-regular fa-arrow-up-right"></i>
          </a>
        </div>
        <div className="row d-flex justify-content-center">
          {/* {_.map(staticIpPlans, (plan, idx) => (
            <div className="col-lg-4" key={idx}>
              <StaticIpCard
                staticIpPlan={plan}
                credits={isCreditApplied ? creditBalance : 0}
                userStaticIp={userStaticIp}
                isIpMandatedBroker={isIpMandatedBroker}
              />
            </div>
          ))} */}
          <StaticIpCard />
        </div>
      </div>
    );
  };

  return (
    <>
      <ul className="nav nav-pills">{tabConfigs.map((tabConfig) => renderli(tabConfig))}</ul>

      {currentTab === 'plans' && (
        <>
          {renderPlanContent()}
          {renderAddonsContent(false)}
        </>
      )}
      {currentTab === 'addons' && renderAddonsContent(true)}
      {currentTab === 'static-ip' && renderStaticIpPlans()}
    </>
  );
};

Mobile.propTypes = propTypes;
Mobile.defaultProps = defaultProps;

export default Mobile;
